import { AxiosResponse } from "axios";

import API from "../api";

import { Recording } from "../models/recording";
import { VideoStatusRoomLog } from "../models/task.room.log";
import { TaskType } from "../models/task.type";
import { SharingData } from "../models/share";

import { Task, TaskTimeControl } from "../models/task";

const ROUTE_NAME = "tasks";

const TaskService = {
  async types(options?: any): Promise<AxiosResponse<TaskType[]>> {
    return await API.get(`/types/${ROUTE_NAME}`, { params: options });
  },
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${ROUTE_NAME}/count`, { params: options });
  },
  async getById(id: number, options?: any): Promise<AxiosResponse<Task>> {
    return await API.get(`/${ROUTE_NAME}/${id}`, { params: options });
  },
  async getRecordings(id: number): Promise<AxiosResponse<Recording[]>> {
    return await API.get(`/${ROUTE_NAME}/recordings/${id}`);
  },
  async getBySearch(search: string, options: any): Promise<AxiosResponse<any>> {
    return await API.get(`/${ROUTE_NAME}/videoSurvey/searchByOr/${search}`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<any>> {
    return await API.get(`/${ROUTE_NAME}`, { params: options });
  },
  async create(task: any): Promise<AxiosResponse<Task>> {
    return await API.post(`/${ROUTE_NAME}`, task);
  },
  async update(id: number, task: any): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/${id}`, task);
  },
  async delete(id: number): Promise<AxiosResponse<any>> {
    return await API.delete(`/${ROUTE_NAME}/${id}`);
  },
  async getVideoStatus(id: number): Promise<AxiosResponse<VideoStatusRoomLog>> {
    return await API.get(`/videosurvey/rooms/status/callback/${id}`);
  },
  async share(sharingData: SharingData, taskId?: number): Promise<AxiosResponse<any>> {
    return await API.post(`/${ROUTE_NAME}/share/${taskId}`, sharingData);
  },
  async cancel(id?: number): Promise<AxiosResponse<Task>> {
    return await API.put(`/${ROUTE_NAME}/cancel/${id}`);
  },
  async assign(id?: number, task?: Task): Promise<AxiosResponse<Task>> {
    return await API.put(`/${ROUTE_NAME}/assign/${id}`, task);
  },
  async sendVideoSurveyNotificationToCustomer(
    id?: number,
    task?: Task
  ): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/videosurvey/customer/notification/${id}`, task);
  },
  async updateTaskTimeControl(
    id?: number,
    taskTimeControl?: TaskTimeControl
  ): Promise<AxiosResponse<Task>> {
    return await API.put(`/${ROUTE_NAME}/${id}/time-control`, taskTimeControl);
  },
  async acceptOrRejectAgentInvite(token: string, action: string) {
    return await API.post(`/${ROUTE_NAME}/agent-invite`, { token, action });
  },
  async sendVideoSurveyLink(data: any): Promise<AxiosResponse<any>> {
    return await API.post(`/${ROUTE_NAME}/send-notification`, data);
  },
};

export default TaskService;
